import React from "react";
import GeneralBookings from "@/components/admin_dashboard/GeneralBookings";
import AttendanceRoster from "@/components/admin_dashboard/AttendanceRoster";
import MakeUpsManagement from "@/components/admin_dashboard/MakeUpsManagement";
import EnrolmentsManagement from "@/components/admin_dashboard/EnrolmentsManagement";
import WaitlistManagement from "@/components/admin_dashboard/WaitlistManagement";
import StorefrontBusinessDetails from "@/components/admin_dashboard/StorefrontBusinessDetails";
import StorefrontListings from "@/components/admin_dashboard/StorefrontListings";
import OutletsManagement from "@/components/admin_dashboard/OutletsManagement";
import ResourcesManagement from "@/components/admin_dashboard/ResourcesManagement";
import { DYNAMIC_PRICING_ENABLED, APPOINTMENT_BOOKING_ENABLED, PROGRAMME_MANAGEMENT_ENABLED } from "@/config/featureFlags";

interface DibsBookingsWorkspaceProps {
  activeSubSection: string;
  onSectionChange: (section: string) => void;
}

export default function DibsBookingsWorkspace({ activeSubSection, onSectionChange }: DibsBookingsWorkspaceProps) {
  return (
    <div className="w-full">
      {/* Main Content Area */}
      <div className="flex-1 min-w-0">
        {activeSubSection === "bookings" && <GeneralBookings />}
        {PROGRAMME_MANAGEMENT_ENABLED && activeSubSection === "enrolments" && <EnrolmentsManagement />}
        {PROGRAMME_MANAGEMENT_ENABLED && activeSubSection === "attendance" && <AttendanceRoster />}
        {PROGRAMME_MANAGEMENT_ENABLED && activeSubSection === "make-ups" && <MakeUpsManagement />}
        {activeSubSection === "waitlist" && <WaitlistManagement />}
        {activeSubSection === "business-details" && <StorefrontBusinessDetails />}
        {activeSubSection === "listings" && (
          <StorefrontListings 
            onNavigateToPricing={
              DYNAMIC_PRICING_ENABLED ? () => onSectionChange("dynamic-pricing") : undefined
            }
          />
        )}
        {activeSubSection === "resources" && APPOINTMENT_BOOKING_ENABLED && <ResourcesManagement />}
        {activeSubSection === "outlets" && <OutletsManagement />}
      </div>
    </div>
  );
}
